<template>
<div class="content-block">
    <footer class="footer">
        <!--Ver {{ ver }} Copyright © 2018 - {{year}} NIPPON EXPRESS Inc.-->
        Ver. {{ ver }} Copyright © NIPPON EXPRESS, All rights reserved
        <!--<br />
      All trademarks or registered trademarks are property of their respective owners.-->
    </footer>
</div>
</template>

<script>
export default {
    data() {
        return {
            year: new Date().getFullYear(),
            ver: process.env.VUE_APP_VER,
        };
    },
};
</script>>

<style lang="scss">
@import "../themes/generated/variables.base.scss";

.footer {
    display: block;
    color: rgba($base-text-color, alpha($base-text-color) * 0.8);
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 10px;
}
</style>
